import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'createby', 'nmcategory', 'jasa', 'requestno',  'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','isproject','approved','pr','statuswf','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = `/inventoryissuedreserved${str}`;
                if (obj.viewOption == "Header") {
                    url = `/inventoryissuedreserved/list${str}`;
                }
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("inventoryissuedreserved", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('obj',obj);
                const { data } = await axios.get(`/inventoryissuedreserved/detail/${obj.invIssueKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailRequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryissuedreserved/detail-request/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/inventoryissuedreserved/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    closed(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/inventoryissuedreserved/closed/${obj.reqdtlkey}`,obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
}